import api from "./api";

// Direcciones: lista corta para elegir la direccion de una filial.
export const getsDireccionesView = async () => {
    const response = await api.get("/Direccion/GetDireccionesView");

    return response.data.data;
}

export const getsDireccionesViewByUbigeoYDetalle = async (idUbigeo, detalle) => {
    const response = await api.get(
        "/Direccion/GetDireccionesViewByUbigeoYDetalle",{params: {idUbigeo, detalle}}
    );

    return response.data.data;
}

// Mantenimiento de direcciones.
export const postDireccion = async (dto) => {
    const response = await api.post("/Direccion/PostDireccion", dto);
    return response.data.data;
}

export const putDireccion = async (dto) => {
    const response = await api.put("/Direccion/PutDireccion", dto);
    return response.data.data;
}

export const deleteDireccion = async (id) => {
    const response = await api.delete("/Direccion/DeleteDireccion?id=" + id);
    return response.data.data;
}

export default {
    getsDireccionesView,
    getsDireccionesViewByUbigeoYDetalle,
};